// import {post, postfile, downFile} from './http'
import {post, postfile, formDownload, postJson} from './http'
const baseUrl = '/api'

// 
export const getMPJSAPIData = v => post(`${baseUrl}/capwhale/system/getMPJSAPIData`, v.data, v.success, v.error)
// 获取手机验证码
export const getSmsCode = v => post(`${baseUrl}/capwhale/system/getSmsCode`, v.data, v.success, v.error)
// 生成图片验证码
export const creatImgCode = v => post(`${baseUrl}/capwhale/user/code`, v.data, v.success, v.error)
// 手机登录
export const loginByMobile = v => post(`${baseUrl}/capwhale/user/loginByMobile`, v.data, v.success, v.error)
// 账号密码登录
export const loginByPassword = v => post(`${baseUrl}/capwhale/user/loginByPassword`, v.data, v.success, v.error)
// 直接注册C用户
export const userRegister = v => post(`${baseUrl}/capwhale/user/userRegister`, v.data, v.success, v.error)
// 用户手机重置密码
export const resetPass = v => post(`${baseUrl}/capwhale/user/resetPass`, v.data, v.success, v.error)
// 微信授权登录
export const getWXLoginInfo = v => post(`${baseUrl}/capwhale/user/getWXLoginInfo`, v.data, v.success, v.error)
// 微信授权登录
export const getCustomerInfo = v => post(`${baseUrl}/capwhale/user/getCustomerInfo`, v.data, v.success, v.error)
// 三方授权登录
export const getLoginByThd = v => post(`${baseUrl}/capwhale/user/getLoginByThd`, v.data, v.success, v.error)
// 根据apptoken获取用户信息
export const getCustomerInfoByApp = v => post(`${baseUrl}/capwhale/user/getCustomerInfoByApp`, v.data, v.success, v.error)

// 微信授权登录
export const getThdLoginInfo = v => post(`${baseUrl}/capwhale/user/getThdLoginInfo`, v.data, v.success, v.error)
// 用户重置密码个人中心使用
export const resetPassBycenter = v => post(`${baseUrl}/capwhale/user/resetPassBycenter`, v.data, v.success, v.error)

// 提交机构关注操作（含关注和取消）
export const uploadCourseHostFollow = v => post(`${baseUrl}/capwhale/course/public/uploadCourseHostFollow`, v.data, v.success, v.error)
// 获取机构详情信息
export const getCourseHostDetailInfo = v => post(`${baseUrl}/capwhale/course/host/getCourseHostDetailInfo`, v.data, v.success, v.error)
// 获取机构全部课程信息
export const getAllCourseByHost = v => post(`${baseUrl}/capwhale/course/host/getAllCourseByHost`, v.data, v.success, v.error)
// 获取机构下全部老师
export const getAllTeacherByHost = v => post(`${baseUrl}/capwhale/course/host/getAllTeacherByHost`, v.data, v.success, v.error)
// 获取老师主页信息
export const getHostTeacherDetail = v => post(`${baseUrl}/capwhale/course/host/getHostTeacherDetail`, v.data, v.success, v.error)
// 搜索课程
export const getMCourseByKey = v => post(`${baseUrl}/capwhale/course/mob/search/getCourseByKey`, v.data, v.success, v.error)
// 获取机构详情信息(mob)
export const getMCourseHostDetailInfo = v => post(`${baseUrl}/capwhale/course/mob/host/getCourseHostDetailInfo`, v.data, v.success, v.error)

// 提交课程收藏操作（含收藏和取消）
export const uploadCourseFavorite = v => post(`${baseUrl}/capwhale/course/public/uploadCourseFavorite`, v.data, v.success, v.error)
// 获取课程详情（含机构信息）
export const getCourseDetail = v => post(`${baseUrl}/capwhale/course/course/getCourseDetail`, v.data, v.success, v.error)
// 获取推荐课程（课程详情）
export const getRecommendCourseByDetail = v => post(`${baseUrl}/capwhale/course/course/getRecommendCourseByDetail`, v.data, v.success, v.error)
// 获取全部笔记（公开的）
export const getAllCourseNotes = v => post(`${baseUrl}/capwhale/course/course/getAllCourseNotes`, v.data, v.success, v.error)
// 获取我的笔记
export const getCourseMyNotes = v => post(`${baseUrl}/capwhale/course/course/getCourseMyNotes`, v.data, v.success, v.error)
// 获取用户评价接口（详情页）
export const getCourseComment = v => post(`${baseUrl}/capwhale/course/course/getCourseComment`, v.data, v.success, v.error)
// 获取课程目录（系列课，通用）
export const getCourseTask = v => post(`${baseUrl}/capwhale/course/course/getCourseTask`, v.data, v.success, v.error)
// 提交参与课程（免费课程有效）
export const uploadCourseJoinInfo = v => post(`${baseUrl}/capwhale/course/course/uploadCourseJoinInfo`, v.data, v.success, v.error)
// 提交用户评价（详情页）
export const uploadCourseComment = v => post(`${baseUrl}/capwhale/course/course/uploadCourseComment`, v.data, v.success, v.error)
// 提交用户讨论信息
export const uploadCourseDiscussInfo = v => post(`${baseUrl}/capwhale/course/course/uploadCourseDiscussInfo`, v.data, v.success, v.error)
// 提交用户笔记
export const uploadCourseNotes = v => post(`${baseUrl}/capwhale/course/course/uploadCourseNotes`, v.data, v.success, v.error)
// 删除课程个人笔记
export const deleteMyCourseNotes = v => post(`${baseUrl}/capwhale/course/course/deleteMyCourseNotes`, v.data, v.success, v.error)
// 获取用户讨论信息（返回最小id做分页）
export const getCourseDiscuss = v => post(`${baseUrl}/capwhale/course/course/getCourseDiscuss`, v.data, v.success, v.error)
// 获取最新讨论信息（返回页面最大id）
export const getCourseNewDiscuss = v => post(`${baseUrl}/capwhale/course/course/getCourseNewDiscuss`, v.data, v.success, v.error)
// 获取课程单任务信息
export const getCourseTaskInfo = v => post(`${baseUrl}/capwhale/course/course/getCourseTaskInfo`, v.data, v.success, v.error)
// 保存用户观看视频进度
export const pushLearnRecord = v => post(`${baseUrl}/capwhale/course/course/pushLearnRecord`, v.data, v.success, v.error)
// 获取资料列表
export const getCourseDocList = v => post(`${baseUrl}/capwhale/course/course/getCourseDoc`, v.data, v.success, v.error)
// 获取海报
export const getAssetPosterList = v => post(`${baseUrl}/capwhale/course/mob/getAssetPosterList`, v.data, v.success, v.error)
// 生成海报
export const makeAssetPoster = v => post(`${baseUrl}/capwhale/course/mob/makeAssetPoster`, v.data, v.success, v.error)
// 下载资料
export const download = v => formDownload(`${baseUrl}/capwhale/course/download`, v.data, v.name, v.success, v.error)

// 获取订单详情
// 获取订单详情
export const getOrderDetail = v => post(`${baseUrl}/capwhale/pay/getOrderDetail`, v.data, v.success, v.error)
export const queryorderpayresult = v => post(`${baseUrl}/capwhale/pay/queryorderpayresult`, v.data, v.success, v.error)
// 提交订单操作
export const uploadPayOrder = v => post(`${baseUrl}/capwhale/pay/uploadPayOrder`, v.data, v.success, v.error)
// 根据订单号调取支付结果返回url
export const getPayResultInfo = v => post(`${baseUrl}/capwhale/pay/getPayResultInfo`, v.data, v.success, v.error)

// 我的
export const getMyInfo = v => post(`${baseUrl}/capwhale/pay/getPayResultInfo`, v.data, v.success, v.error)

// export const qiniuFormUpload = v => postfile(v.url, v.data, v.success, v.error)
// export const exportReportNameList = v => downFile(`${baseUrl}/admin/kmc/report/exportList`, v.data, v.success, v.error)

// 文件上传 获取表单上传需要的表单属性 云上传模式
export const getUploadParam = v => post(`${baseUrl}/upload/getFileUploadFormInfo`, v.data, v.success, v.error)
export const qiniuFormUpload = v => postfile(v.url, v.data, v.success, v.error)

//获取订单详情（题库）
export const getQbankOrderDetail = v => post(`${baseUrl}/capwhale/pay/getQbankOrderDetail`, v.data, v.success, v.error)
//订单中心-去支付（活动）
export const getOrderPayUrl = v => post(`${baseUrl}/capwhale/pay/getOrderPayUrl`, v.data, v.success, v.error)

// 题库
export const getTopicQuesBankInfo = v => post(`${baseUrl}/capwhale/questionbank/questionbank/getTopicQuesBankInfo`, v.data, v.success, v.error)
export const getTopicUserExamList = v => post(`${baseUrl}/capwhale/questionbank/questionbank/getTopicUserExamList`, v.data, v.success, v.error)
export const updateStartExam = v => post(`${baseUrl}/capwhale/questionbank/questionbank/updateStartExam`, v.data, v.success, v.error)
export const uploadPauseExam = v => post(`${baseUrl}/capwhale/questionbank/questionbank/uploadPauseExam`, v.data, v.success, v.error)
export const uploadJoinTopicQuesBank = v => post(`${baseUrl}/capwhale/questionbanktopic/uploadJoinTopicQuesBank`, v.data, v.success, v.error)
export const getTopicQBBaseInfo = v => post(`${baseUrl}/capwhale/questionbanktopic/getTopicQBBaseInfo`, v.data, v.success, v.error)

// 领取优惠券
export const getReceiveCouponVoucher = v => post(`${baseUrl}/capwhale/center/getReceiveCouponVoucher`, v.data, v.success, v.error)
// 个人中心优惠券列表
export const getMyCoupongetinfo = v => post(`${baseUrl}/capwhale/center/getMyCoupongetinfo`, v.data, v.success, v.error)
// 内容可领优惠券列表接口
export const getCouponVoucherList = v => post(`${baseUrl}/capwhale/center/getCouponVoucherList`, v.data, v.success, v.error)

// 问卷
export const getCourseCommonformInfo = v => post(`${baseUrl}/capwhale/course/mob/course/getCourseCommonformInfo`, v.data, v.success, v.error)
export const uploadCommonFormInfo = v => post(`${baseUrl}/capwhale/course/public/uploadCommonFormInfo`, v.data, v.success, v.error)

// 获取动态详情
export const getDiaryBaseInfo = v => postJson(`${baseUrl}/capwhale/dm/diary/getDiaryBaseInfo`, v.data, v.success, v.error)
// 获取动态评论列表
export const getDiaryCommentList = v => postJson(`${baseUrl}/capwhale/dm/diary/getDiaryCommentList`, v.data, v.success, v.error)
// 获取话题详情
export const getVTopicBaseInfo = v => postJson(`${baseUrl}/capwhale/dm/diary/getVTopicBaseInfo`, v.data, v.success, v.error)
// 获取话题动态列表
export const getVTopicDiaryList = v => postJson(`${baseUrl}/capwhale/dm/diary/getVTopicDiaryList`, v.data, v.success, v.error)